import React, { useState } from "react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      category: "Booking & Reservations",
      questions: [
        {
          q: "How do I book a flight on TripReserver?",
          a: "Simply enter your departure city, destination, and travel dates into our search widget on the home page. Browse the results, select your preferred flight, and follow the secure checkout process.",
        },
        {
          q: "Are taxes and fees included in the final price?",
          a: "Yes. We believe in complete transparency. All mandatory taxes and airline fees are included in the final price shown on the checkout page before you pay.",
        },
        {
          q: "Can I book a flight for someone else?",
          a: "Absolutely. During the checkout process, simply enter the passenger's details exactly as they appear on their government-issued ID. You can enter your own details in the billing section.",
        },
      ],
    },
    {
      category: "Cancellations & Changes",
      questions: [
        {
          q: "What is your cancellation policy?",
          a: "Cancellation policies are determined by the airline and the specific fare class you purchased. Many airlines offer a 24-hour risk-free cancellation window. You can check your specific rules in the 'Manage Booking' portal.",
        },
        {
          q: "How do I change the date of my flight?",
          a: "To change a flight, navigate to 'Manage Booking' or call our 24/7 support line. Note that airlines may charge a change fee plus any difference in fare.",
        },
      ],
    },
  ];

  const toggleAccordion = (categoryIndex, questionIndex) => {
    const indexStr = `${categoryIndex}-${questionIndex}`;
    setActiveIndex(activeIndex === indexStr ? null : indexStr);
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans py-16 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h1 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-slate-500 text-lg font-medium">
            Find answers to our most common questions below.
          </p>
        </div>

        <div className="space-y-12">
          {faqs.map((group, cIdx) => (
            <div key={cIdx}>
              <h2 className="text-xl font-black text-slate-900 mb-6">
                {group.category}
              </h2>
              <div className="space-y-4">
                {group.questions.map((faq, qIdx) => {
                  const isActive = activeIndex === `${cIdx}-${qIdx}`;
                  return (
                    <div
                      key={qIdx}
                      className={`bg-white border rounded-2xl transition-all duration-300 overflow-hidden ${isActive ? "border-blue-500 shadow-md shadow-blue-500/10" : "border-slate-200 hover:border-blue-300"}`}
                    >
                      <button
                        onClick={() => toggleAccordion(cIdx, qIdx)}
                        className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none"
                      >
                        <span className="font-bold text-slate-900 pr-4">
                          {faq.q}
                        </span>
                        <div
                          className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isActive ? "bg-blue-100 text-blue-600" : "bg-slate-100 text-slate-400"}`}
                        >
                          <svg
                            className={`w-4 h-4 transition-transform duration-300 ${isActive ? "rotate-180" : ""}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2.5"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </button>
                      <div
                        className={`px-6 text-slate-600 leading-relaxed transition-all duration-300 ease-in-out ${isActive ? "max-h-96 pb-5 opacity-100" : "max-h-0 pb-0 opacity-0"}`}
                      >
                        {faq.a}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Support CTA */}
        <div className="mt-16 bg-blue-600 rounded-[2rem] p-8 sm:p-12 text-center shadow-xl shadow-blue-600/20">
          <h3 className="text-2xl font-black text-white mb-3">
            Still have questions?
          </h3>
          <p className="text-blue-100 mb-8 max-w-lg mx-auto">
            Our travel experts are available 24/7 to help you with booking,
            changes, and special requests.
          </p>
          <button className="bg-white text-blue-900 font-bold py-3.5 px-8 rounded-xl shadow-lg hover:bg-slate-50 transition-colors active:scale-95">
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
